export enum ReportGenerationReferenceDate {
    Current = 'current',
    Previous = 'previous',
    PrePrevious = 'preprevious',
}
